import React from "react";
import { motion } from "framer-motion";

const Skills = () => {
  const analyticsSkills = [
    { title: "Business Intelligence & Reporting", percent: 100 },
    { title: "Data Modeling & Star Schema", percent: 90 },
    { title: "DAX & Analytical Calculations", percent: 90 },
    { title: "Data Visualization & Storytelling", percent: 95 },
    { title: "Performance Optimization", percent: 95 },
    { title: "Requirement Gathering & Analysis", percent: 90 },
    { title: "Data Validation", percent: 95 },
    { title: "Incremental Refresh & Data Quality", percent: 90 },
  ];

  const devSkills = [
    { title: "Power BI Desktop", percent: 100 },
    { title: "Power BI Service", percent: 95 },
    { title: "SQL Server", percent: 90 },
    { title: "Microsoft Fabric", percent: 75 },
    { title: "Azure SQL", percent: 80 },
    { title: "Power Query (M Language)", percent: 90 },
    { title: "On-Prem Data Gateway", percent: 90 },
    { title: "Data Warehouse", percent: 90 },
  ];

  const SkillCard = ({ skills, title }) => (
    <motion.div
      whileHover={{
        y: -1.5,
        scale: 1.006,
      }}
      transition={{
        duration: 0.35,
        ease: "easeOut",
      }}
      className="relative"
    >
      <div
        className="
          relative z-10
          bg-gradient-to-r from-bodyColor to-[#202327]
          rounded-2xl p-8
          border border-gray-800 hover:border-designColor
          shadow-shadowOne
          transition-colors duration-300
        "
      >
        <h2 className="text-2xl font-bold mb-6 text-gray-200">
          {title}
        </h2>

        <div className="flex flex-col gap-5">
          {skills.map((skill, idx) => (
            <div key={idx}>
              <div className="flex justify-between items-center mb-1">
                <p className="text-sm text-gray-300 hover:text-white transition-colors">
                  {skill.title}
                </p>
                <span className="text-sm text-gray-400 hover:text-designColor transition-colors">
                  {skill.percent}%
                </span>
              </div>

              <div className="w-full h-2.5 bg-gray-800 rounded-full overflow-hidden">
                <motion.div
                  initial={{ width: 0 }}
                  animate={{ width: `${skill.percent}%` }}
                  transition={{ duration: 1.3, ease: "easeOut" }}
                  className="h-full rounded-full bg-designColor"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </motion.div>
  );

  return (
    <div className="w-full grid grid-cols-1 lgl:grid-cols-2 gap-12 mt-12">
      <SkillCard skills={analyticsSkills} title="Analytics & BI Skills" />
      <SkillCard skills={devSkills} title="Tools & Platforms" />
    </div>
  );
};

export default Skills;
